import React, { useMemo, useState } from 'react'
import './MakroFilter.scss'
import { ReactComponent as CloseIcon } from '../../components/assets/MakroPage/CloseModal.svg'
import { ReactComponent as ZoomIcon } from '../../components/assets/MakroPage/ZoomIcon.svg'
import MakroCheckBox from '../MakroCheckBox/MakroCheckBox'


const MakroFilter = ({ onClose=null, filters, setFilters, items, sx={}}) => {
  const [localSearch, setLocalSearch] = useState(filters.search || '')

  const categoriesData = useMemo(() => {
    const counts = items?.reduce((acc, item) => {
      // Если категории нет, пропускаем
      if (!item.category) return acc;

      // Разбиваем строку по запятой и убираем лишние пробелы
      const categories = item?.category?.split(',')?.map(cat => cat?.trim());

      categories?.forEach(cat => {
        if (cat) { // Проверка на пустую строку
          acc[cat] = (acc[cat] || 0) + 1;
        }
      });

      return acc;
    }, {})

    return Object.entries(counts || {})?.map(([name, count], index) => ({
      id: index,
      name,
      count
    }))
  }, [items]);

  const brandsData = useMemo(() => {
    const counts = items?.reduce((acc, item) => {
      if (!item?.brand) return acc
      acc[item?.brand] = (acc[item?.brand] || 0) + 1
      return acc
    }, {})

    return Object.entries(counts)?.map(([name, count], index) => ({
      id: name, // используем имя бренда как ID
      name,
      count
    }))
  }, [items])

  // --- Handlers ---

  const handleSearchChange = (e) => {
    const value = e.target.value
    setLocalSearch(value)
    setFilters(prev => ({ ...prev, search: value }))
  }

  const handleCategoryClick = (categoryName) => {
    console.log(filters)
    if (filters?.category?.includes(categoryName)) {
      setFilters(prev => ({ ...prev, category: prev?.category?.filter(c => c !== categoryName) }))
    } else {
      setFilters(prev => ({ ...prev, category: [...prev.category, categoryName] }))
    }
    // Можно закрывать модалку после выбора категории, если это предусмотрено логикой
    // onClose()
  }

  const handleBrandToggle = (brandName) => {
    setFilters(prev => {
      const currentBrands = prev?.brands || []
      const newBrands = currentBrands.includes(brandName)
        ? currentBrands.filter(b => b !== brandName)
        : [...currentBrands, brandName]
      
      return { ...prev, brands: newBrands }
    })
  }

  const handleDeliveryToggle = () => {
    setFilters(prev => ({ ...prev, courierDelivery: !prev?.courierDelivery }))
  }

  return (
    <div className='MakroFilter' style={sx}>
      <div className="Search">
        <div className="rw">
          <h2>Search</h2>
          {onClose !== null && <div onClick={onClose} style={{ cursor: 'pointer' }}>
            <CloseIcon />
          </div>}
        </div>
        <div className="rw">
          <div className="Search__input">
            <input 
              type="text"
              placeholder='Narrow search...'
              className='Search__input__input'
              value={localSearch}
              onChange={handleSearchChange}
            />
            <ZoomIcon />
          </div>
        </div>
      </div>
      <div className="Delivery">
        <div className="rw">
          <h2>Delivery Channel</h2>
        </div>
        <div className="rw" style={{ marginTop: '10px' }}>
          <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '8px' }}>
            <MakroCheckBox 
              checked={!!filters?.delivery}
              onChange={handleDeliveryToggle}
            />
            <span>Courier delivery (51)</span>
          </label>
        </div>
      </div>
      {categoriesData?.length > 0 && <div className="Categories">
        <div className="rw">
          <h2>Categories</h2>
        </div>
        <div className="Categories__list">
          {categoriesData?.map((cat, i) => (
            <div 
              key={cat?.id + i} 
              className={`rw Categories__list__item ${filters?.category?.includes(cat?.name) ? 'active' : ''}`}
              onClick={() => handleCategoryClick(cat.name)}
              style={{ cursor: 'pointer', color: filters?.category?.includes(cat?.name) ? '#000' : '#2b6bf3' }}
            >
              <span>{cat?.name} ({cat?.count})</span>
              <span>&gt;</span> {/* Стрелочка вправо */}
            </div>
          ))}
        </div>
      </div>}
      {brandsData?.length > 0 && <div className="Brand">
        <div className="rw">
          <h2>Brand</h2>
        </div>

        {/* Brands List */}
        <div className="brands-list">
          {brandsData?.map((brand, index) => (
            <label key={`${brand?.id}-${index}`}>
                <MakroCheckBox 
                  checked={filters?.brands?.includes(brand.name)}
                  onChange={() => handleBrandToggle(brand.name)}
                />
                <span>{brand?.name} ({brand?.count})</span>
            </label>
          ))}
        </div>
      </div>}
    </div>
  )
}

export default MakroFilter